import { utm } from '../../utils/utm';
import { initCustomerIO } from '../../utils/customer-io';

class FormBlock {
  /**
   * Add custom JavaScript to the block HTML.
   *
   * @param   Element  block       The block element
   * @param   object   attributes  The block attributes (only available when editing)
   * @return  void
   */
  constructor(block, attributes = null) {
    if (block.hasAttribute('data-ignore')) {
      return;
    }

    this.block = block;
    this.wrapper = block.querySelector('.form__wrapper');
    this.form = block.querySelector('.form__form');
    this.innerBlocks = block.querySelectorAll('.block__inner-blocks > *');
    this.groups = this.form.querySelectorAll('.form__group');
    this.errors = this.form.querySelectorAll('.error-text');
    this.recaptcha = this.form.querySelector('input[data-recaptcha]');
    this.submit = this.form.querySelector('button[type="submit"]');
    this.success = this.block.querySelector('.form__success');
    this.steps = [];
    this.customerIoFormId = this.block.dataset.customerIoFormId;

    window._mfq = window._mfq || [];

    if (this.customerIoFormId) {
      initCustomerIO();
    }

    if (this.recaptcha && window.grecaptcha) {
      grecaptcha.ready(() => {
        this.refreshRecaptcha();
        setInterval(() => this.refreshRecaptcha(), 60000);
      });
    }

    if (utm) {
      Object.keys(utm).forEach((p) => {
        if (utm[p]) {
          const utmInput = document.createElement('input');
          utmInput.hidden = true;
          utmInput.name = p === 'gclid' ? p : `utm_${p}`;
          utmInput.value = utm[p];
          this.form.append(utmInput);
        }
      });
    }

    if ([...this.groups].some((group) => group.classList.contains('form__group--step'))) {
      const steps = document.createElement('div');
      steps.classList.add('form__steps');
      this.wrapper.appendChild(steps);
      let i = 1;

      this.groups.forEach((group) => {
        const inputs = group.querySelectorAll('input');
        const selects = group.querySelectorAll('select');

        inputs.forEach((input) => input.addEventListener('change', () => this.refresh()));
        selects.forEach((select) => select.addEventListener('change', () => this.refresh()));

        if (group.classList.contains('form__group--step')) {
          const step = document.createElement('div');
          step.classList.add('form__step');
          step.classList.add(`form__step--${i}`);
          steps.appendChild(step);
          this.steps.push(step);
          i++;
        }
      });

      window.addEventListener('resize', () => this.updateStepBar());

      this.refresh();

      setTimeout(() => {
        this.updateStepBar();
      }, 0);
    }

    this.form.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);
      formData.append('action', 'submit');

      this.groups.forEach((group) => group.classList.remove('has-errors'));
      this.errors.forEach((error) => (error.innerHTML = ''));
      this.submit.disabled = true;

      window._mfq.push(['formSubmitAttempt', `#${this.form.id}`]);

      if (this.customerIoFormId && window._cio) {
        _cio.track('formSubmitAttempt', {
          formId: this.customerIoFormId,
          url: window.location.href,
        });
      }

      fetch(ajaxurl, {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.success) {
            window._mfq.push(['formSubmitSuccess', `#${this.form.id}`]);

            if (this.customerIoFormId && window._cio) {
              if (formData.get('email')) {
                _cio.identify({
                  id: formData.get('email'),
                });
              }

              _cio.track('formSubmitSuccess', {
                formId: this.customerIoFormId,
                url: window.location.href,
              });
            }

            this.block.querySelector('.form__form').dispatchEvent(new CustomEvent('form-success'));

            if (data.data && data.data.redirectTo) {
              window.location.href = data.data.redirectTo;
            } else {
              this.form.style.height = this.form.scrollHeight + 'px';
              this.form.classList.add('sales-form-success');

              const steps = document.querySelector('.form__steps');

              if (steps) {
                steps.style.display = 'none';
              }

              const _form = this.block.querySelector('.form__form');

              if (_form) {
                _form.style.overflow = 'hidden';
              }

              setTimeout(() => {
                this.form.style.height = 0;
                this.success.style.height = this.success.scrollHeight + 'px';

                setTimeout(() => {
                  this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }, 400);
              }, 100);

              if (data.data && data.data.download) {
                const date = new Date();
                date.setTime(date.getTime() + 365 * 24 * 60 * 60 * 1000);
                document.cookie = `wp-vb-token=${data.data.download.token}; expires=${date.toUTCString()}; path=/`;
                // console.log(this.success.innerHTML);
                this.success.innerHTML = this.success.innerHTML.replace(
                  '[link]',
                  `<a href="${data.data.download.url}" target="_blank">Download link</a>`
                );
                window.open(data.data.download.url, '_blank');
              }
            }
          } else {
            window._mfq.push(['formSubmitFailure', `#${this.form.id}`]);

            if (this.customerIoFormId && window._cio) {
              _cio.track('formSubmitFailure', {
                formId: this.customerIoFormId,
                url: window.location.href,
              });
            }

            for (let name in data.data) {
              if (data.data[name].length) {
                const groupEl = this.form.querySelector(`.form__group[data-name="${name}"]`);
                const errorEl = groupEl && groupEl.querySelector('.error-text');

                if (groupEl) {
                  groupEl.classList.add('has-errors');
                }

                if (errorEl) {
                  errorEl.innerHTML = data.data[name][0];
                }
              }

              this.submit.disabled = false;
              this.refreshRecaptcha();
            }
          }
        });
    });

    // Tooltip
    const tooltip = this.block.querySelector('.tooltip');
    const checkbox = this.block.querySelector('.form__group--checkbox');
    const _form = this.block.querySelector('.form__form');

    if (checkbox) {
      if (tooltip) {
        checkbox.append(tooltip);
      }

      checkbox.style.display = 'flex';
      checkbox.style.justifyContent = 'space-between';
      checkbox.style.gap = '24px';

      if (window.innerWidth < 768) {
        checkbox.style.flexDirection = 'column';

        if (tooltip) {
          tooltip.style.marginLeft = 'auto';
        }
      }

      if (_form) {
        _form.style.overflow = 'visible';
      }
    }

    if (tooltip) {
      tooltip.style.display = '';
      tooltip.style.marginTop = '4px';
      document.addEventListener('click', () => {
        tooltip.classList.remove('tooltip-open');
      });
    }
  }

  refresh() {
    this.refreshConditionalLogic();
    this.refreshSteps();
    this.updateStepBar();
  }

  refreshSteps() {
    let filled = true;
    let currentGroupStep = null;
    let skip = false;
    let i = 1;

    this.steps.forEach((step) => {
      step.classList.remove('form__step--visible');
      step.classList.remove('form__step--filled');
      step.classList.remove('form__step--active');
    });

    this.groups.forEach((group) => {
      if (group.classList.contains('form__group--step')) {
        if (!group.classList.contains('form__group--hidden')) {
          this.steps.find((step) => step.classList.contains(`form__step--${i}`))?.classList.add('form__step--visible');
        }

        i++;
      }
    });

    i = 1;

    this.groups.forEach((group) => {
      if (skip && !group.classList.contains('form__group--step')) {
        return;
      }

      skip = false;

      const inputs = group.querySelectorAll('input');
      const selects = group.querySelectorAll('select');

      if (group.classList.contains('form__group--step')) {
        if (group.classList.contains('form__group--hidden')) {
          skip = true;
        } else {
          if (currentGroupStep) {
            if (currentGroupStep.disable) {
              currentGroupStep.groups.forEach((group) => group.classList.add('is-disabled'));
            } else {
              currentGroupStep.groups.forEach((group) => group.classList.remove('is-disabled'));
            }

            if (filled) {
              currentGroupStep.step.classList.add('form__step--filled');
            }
          }

          currentGroupStep = {
            step: this.steps.find((step) => step.classList.contains(`form__step--${i}`)),
            groups: [],
            disable: !filled,
          };
        }

        i++;
      } else {
        if (currentGroupStep) {
          currentGroupStep.groups.push(group);
        }

        inputs.forEach((input) => {
          if (input.type === 'radio' || input.type === 'checkbox') {
            filled = filled && !!group.querySelector(`[name="${input.name}"]:checked`);
          } else {
            filled = filled && !!input.value;
          }
        });

        selects.forEach((select) => {
          if (!select.value || select.value === 'no_select') {
            filled = false;
          }
        });
      }
    });

    // For the last group
    if (currentGroupStep) {
      if (currentGroupStep.disable) {
        currentGroupStep.groups.forEach((group) => group.classList.add('is-disabled'));
      } else {
        currentGroupStep.groups.forEach((group) => group.classList.remove('is-disabled'));
      }

      if (filled) {
        currentGroupStep.step.classList.add('form__step--filled');
      }
    }

    const visibleSteps = this.steps.filter((step) => step.classList.contains('form__step--visible'));

    visibleSteps.find((step) => !step.classList.contains('form__step--filled'))?.classList.add('form__step--active');
  }

  updateStepBar() {
    let i = 1;

    this.groups.forEach((group) => {
      if (group.classList.contains('form__group--step')) {
        const step = this.steps.find((step) => step.classList.contains(`form__step--${i}`));

        if (step) {
          step.style.top = `${group.offsetTop}px`;
        }

        i++;
      }
    });
  }

  refreshConditionalLogic() {
    this.groups.forEach((group, i) => {
      if (group.dataset.cl) {
        const cl = JSON.parse(group.dataset.cl);
        const subGroups = [...this.groups].slice(i);
        subGroups.splice(subGroups.findIndex((sg, i) => i > 0 && sg.classList.contains('form__group--step')));

        const visible = cl.every((r) => {
          const field = this.form.querySelector(`[name="formData[${r.name}]"]`);

          if (field && field.type === 'radio') {
            const checked = this.form.querySelector(`[name="formData[${r.name}]"]:checked`);
            return checked && checked.value == r.value;
          }

          return field && field.value == r.value;
        });

        // console.log(cl, visible);

        if (visible) {
          subGroups.forEach((sg) => sg.classList.remove('form__group--hidden'));
        } else {
          subGroups.forEach((sg) => sg.classList.add('form__group--hidden'));
        }
      }
    });
  }

  refreshRecaptcha() {
    if (this.recaptcha && !this.submit.disabled) {
      grecaptcha
        .execute(this.recaptcha.dataset.recaptcha, {
          action: 'homepage',
        })
        .then((token) => {
          this.recaptcha.value = token;
        });
    }
  }
}

// Initialize each block on page load (front end)
document.querySelectorAll('.form').forEach((block) => {
  new FormBlock(block);
});

// Initialize the dynamic block preview (editor)
if (window.acf) {
  window.acf.addAction('render_block_preview/type=form', ($block, attributes) => {
    new FormBlock($block.find('.form').get(0), attributes);
  });
}

export { FormBlock };